import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { getTerminal, updateTerminal } from '@/apis/terminals'
import useNotification from '@/hooks/useNotification'
import {
  GetTerminalRequest,
  GetTerminalResponse,
  UpdateTerminalRequest,
  UpdateTerminalResponse,
} from '@/types/apis/terminals'

export const useUpdateTerminals = () => {
  const { t } = useTranslation()
  const openNotification = useNotification()
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<UpdateTerminalResponse>()

  const update = useCallback(
    async (request: UpdateTerminalRequest) => {
      try {
        setLoading(true)
        const res = await updateTerminal(request)
        setResponse(res)
        openNotification({ description: t('pages.terminals.update.updateSuccessfully') })
      } finally {
        setLoading(false)
      }
    },
    [openNotification, t]
  )

  return {
    loading,
    updateTerminal: update,
    response,
  }
}

export const useGetTerminal = () => {
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<GetTerminalResponse>()

  const get = useCallback(async (request: GetTerminalRequest) => {
    try {
      setLoading(true)
      const res = await getTerminal(request)
      setResponse(res)
    } finally {
      setLoading(false)
    }
  }, [])

  return {
    loading,
    getTerminal: get,
    response,
  }
}
